import { Site } from "../../../../shared/entities/scripts/site";
import { Study } from "../../../../shared/entities/scripts/study";
import { ForecastGraphDataPoint } from "../../forcasts/scripts/forecasts.entities";
import { Participant } from "./enrollment.entities";
import { EnrollmentLookup } from "./enrollment.lookup";
import { IEnrollmentPageData } from "./enrollment.page";
import { siteColors } from "./enrollment.chart-controller";


var Highcharts = require('highcharts/highcharts');
require('highcharts/highcharts-more')(Highcharts);


export class ChartPie {

    constructor(public parent: IEnrollmentPageData) { }

    UpdatePieChart(indices: number[]): void {

        let chartData: any[] = [];
        let showLegend: boolean = true;

        if (indices != undefined) {
            let data: number[] = [];
            if (this.parent.selectedBreakdown == "Age") { data = this.parent.aggregatedParticipants.Age; }
            else if (this.parent.selectedBreakdown == "Race") { data = this.parent.aggregatedParticipants.Race; }
            else if (this.parent.selectedBreakdown == "Ethnicity") { data = this.parent.aggregatedParticipants.Hispanic; }
            else if (this.parent.selectedBreakdown == "Hispanic Or Non-White") { data = this.parent.aggregatedParticipants.NonWhiteHispanic; }
            else if (this.parent.selectedBreakdown == "Sex") { data = this.parent.aggregatedParticipants.Sex; }

            indices.forEach((index: number) => {
                let label: string = "";
                if (this.parent.selectedBreakdown == "Ethnicity" || this.parent.selectedBreakdown == "Hispanic Or Non-White") {
                    label = EnrollmentLookup.GetYesNo(index);
                    if (this.parent.selectedBreakdown == "Ethnicity" && label != "Unknown") {
                        label = (label == "Yes") ? "Hispanic" : "Not Hispanic";
                    }
                }
                else if (this.parent.selectedBreakdown == "Sex") {
                    label = EnrollmentLookup.GetSex(index);
                }
                else if (this.parent.selectedBreakdown == "Age") {
                    label = EnrollmentLookup.GetAgeGroup(index);
                }
                else if (this.parent.selectedBreakdown == "Race") {
                    label = EnrollmentLookup.GetRace(index);
                }

                chartData.push({ name: label, y: data[index], className: ChartPie.GetClassName(label) });
            });
        }
        else { //an "All Participants" view
            let remainingLabel: string = "Total";
            let countFound: number = 0;

            if (this.parent.selectedAggregation == "Overall") {
                chartData.push({ name: 'Participants', y: this.parent.selectedParticipants.length, className: ChartPie.GetClassName("TOTAL") });

                //if 'All Participants', show forecasted
                if (this.parent.selectedBreakdown == "All Participants" && this.parent.selectedForecastRandomized.length > 0) {
                    chartData.push({ name: 'Total Target Remaining', y: this.getTargetRemaining(this.parent.selectedParticipants.length), className: ChartPie.GetClassName("TARGET") });
                }
            }
            else if (this.parent.selectedAggregation == "ByStudy") {
                this.parent.allStudies.forEach((s: Study) => {
                    let count: number = this.parent.selectedParticipants.filter((p: Participant) => p.StudyID == s.Id).length;
                    if (count > 0) {
                        chartData.push({ name: s.Name, y: count, className: ChartPie.GetClassName(s.Name) });
                        countFound += count;
                    }
                });
                if (chartData.length == 1) {
                    remainingLabel = chartData[0].name;
                }
                chartData.push({ name: remainingLabel + " Target Remaining", y: this.getTargetRemaining(countFound), className: ChartPie.GetClassName("TARGET") });
            }
            else if (this.parent.selectedAggregation == "BySite") {
                let colorIdx: number = 0;
                this.parent.consentedSites.forEach((s: Site) => {
                    let color = siteColors[colorIdx % siteColors.length];
                    let classname = "PieStyle-" + color.replace("#", "");
                    chartData.push({ name: s.Name, y: this.parent.selectedParticipants.filter((p: Participant) => p.SiteNumber == s.Id).length, className: classname });
                    document.styleSheets[0].insertRule("." + classname + " {fill: " + color + "; stroke: " + color + "; }", 0);
                    document.styleSheets[0].insertRule("." + classname + ".highcharts-point {fill: " + color + "; stroke: " + color + "; }", 0);
                    colorIdx++;
                });

                showLegend = false;
            }

        }

        this.updateChart(chartData, showLegend);

    }

    updateChart(data: any[], showLegend: boolean = true): void {

        //eventually should not need to use CSS to stle this
        //$('#chart-display').removeClass('piestyle-yes-no piestyle-age piestyle-sex piestyle-race piestyle-all-overall piestyle-all-bystudy piestyle-all-byappendix');

        //if (displayStyle != "") { $('#chart-display').addClass(displayStyle); }

        Highcharts.chart('enrollment-chart', {
            chart: {
                type: 'pie',
                //styledMode: false //this seems to be ignored either way
            },
            title: {
                text: undefined
            },
            tooltip: {
                //pointFormat: '{point.percentage:.0f}% (n={point.y:,.0f})',
                shared: false,
                formatter: function () {
                    //return '<div class="tooltip" style="border-color:' + this.point.color + ';"><b>' + this.point.name + '</b><br/>' + Highcharts.numberFormat(this.point.percentage, 0, '', ',') + '% (n=' + Highcharts.numberFormat(this.point.y, 0, '', ',') + ')</div>';                    
                    return '<b>' + this.point.name + '</b><br>' + Highcharts.numberFormat(this.point.percentage, 0, '', ',') + '% (n=' + Highcharts.numberFormat(this.point.y, 0, '', ',') + ')';
                },
                borderColor: 'black'
            },
            credits: { enabled: false },
            plotOptions: {
                pie: {
                    allowPointSelect: false,
                    cursor: 'pointer',
                    dataLabels: {
                        connectorWidth: 1,
                        connectorShape: 'crookedLine',
                        crookDistance: '0%',
                        //enabled: false,
                        format: '<b>{point.name}</b><br>{point.percentage:.0f}% (n={point.y:,.0f})',
                        //distance: -50,
                        style: {
                            fontWeight: 'normal',
                            fontSize: '13px'
                        },
                        filter: {
                            property: 'percentage',
                            operator: '>',
                            value: 0
                        }
                    },
                    showInLegend: true
                }
            },
            series: [{
                colorByPoint: true,
                type: 'pie',
                data: data,
            }],
            legend: {
                enabled: showLegend
            }
        });
    }

    private getTargetRemaining(enrolledCount: number): number {
        let total: number = 0;
        this.parent.selectedForecastRandomized.forEach((x: ForecastGraphDataPoint) => total += x.Count);
        total = total - enrolledCount;
        if (total < 0) total = 0;
        return total;
    }

    static GetClassName(value: string): string {
        if (value == "TOTAL") { return "piestyle-safronyellow"; }
        else if (value == "REVERSE-LC") { return "piestyle-airblue"; }
        else if (value == "Yes") { return "piestyle-airblue"; }
        else if (value == "No") { return "piestyle-safronyellow"; }
        else if (value == "Unknown") { return "piestyle-gray"; }
        else if (value == "Hispanic") { return "piestyle-airblue"; }
        else if (value == "Not Hispanic") { return "piestyle-safronyellow"; }
        else if (value == "Female") { return "piestyle-airblue"; }
        else if (value == "Male") { return "piestyle-safronyellow"; }
        else if (value == "Intersex") { return "piestyle-cambridgeblue"; }
        else if (value == "Prefer Not To Answer") { return "piestyle-mountbattenpink"; }
        else if (value == "18-45") { return "piestyle-safronyellow"; }
        else if (value == "46-65") { return "piestyle-airblue"; }
        else if (value == ">65") { return "piestyle-cambridgeblue"; }
        else if (value == "AIAN") { return "piestyle-sandyorange"; }
        else if (value == "Asian") { return "piestyle-mountbattenpink"; }
        else if (value == "Black") { return "piestyle-airblue"; }
        else if (value == "MENA") { return "piestyle-chestnutred"; }
        else if (value == "NHPI") { return "piestyle-ceruleanblue"; }
        else if (value == "Multi") { return "piestyle-cambridgeblue"; }
        else if (value == "White") { return "piestyle-safronyellow"; }
        else if (value == "Other") { return  "piestyle-rosetaupe" }
        else return "piestyle-gray";
    }    

}